<template>
	<div class="data-container">
		<el-select v-model="select_value" placeholder="请选择">
			<el-option
			  v-for="item in options"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value"
			>
			</el-option>
		</el-select>
		<div class="chart" id="echarts"></div>
	</div>
</template>

<script>

import *as echarts from 'echarts'

export default ({
	name: 'ElectricityEcharts',
	props: {
		deviceId: {
			validator: null // 禁用类型检查
		}
	},
	data() {
		return {
			// select 选择
			options: [{
				value: '1',
				label: '最近24小时'
			}, {
				value: '7',
				label: '最近7天',
			}, {
				value: '30',
				label: '最近30天',
			}],
			select_value: '1',
			option: {

				title: {
					text: '瞬时功率',
					left: 'center',
				},
				tooltip: {
					trigger: 'axis'
				},
				grid: {
					left: '5%',
					right: '10%',
					bottom: '10%'
				},
				xAxis: {
					data: []
				},
				yAxis: {},
				// toolbox: {
				// 	right: 10,
				// 	feature: {
				// 		dataZoom: {
				// 			yAxisIndex: 'none'
				// 		},
				// 		restore: {},
				// 		saveAsImage: {}
				// 	}
				// },
				dataZoom: [
					{
						startValue: '2014-06-01'
					},
					{
						type: 'inside'
					}
				],
				// visualMap: {
				// 	top: 50,
				// 	right: 10,
				// 	pieces: [
				// 		{
				// 			gt: 0,
				// 			lte: 50,
				// 			color: '#93CE07'
				// 		},
				// 		{
				// 			gt: 50,
				// 			lte: 100,
				// 			color: '#FBDB0F'
				// 		},
				// 		{
				// 			gt: 100,
				// 			lte: 150,
				// 			color: '#FC7D02'
				// 		},
				// 		{
				// 			gt: 150,
				// 			lte: 200,
				// 			color: '#FD0100'
				// 		},
				// 		{
				// 			gt: 200,
				// 			lte: 300,
				// 			color: '#AA069F'
				// 		},
				// 		{
				// 			gt: 300,
				// 			color: '#AC3B2A'
				// 		}
				// 	],
				// 	outOfRange: {
				// 		color: '#999'
				// 	}
				// },
				series: [
					{
						name: '功率',
						type: 'line',
						data: [],
						// markLine: {
						// 	silent: true,
						// 	lineStyle: {
						// 		color: '#333'
						// 	},
						// 	data: [
						// 		{
						// 			yAxis: 50
						// 		},
						// 		{
						// 			yAxis: 100
						// 		},
						// 		{
						// 			yAxis: 150
						// 		},
						// 		{
						// 			yAxis: 200
						// 		},
						// 		{
						// 			yAxis: 300
						// 		}
						// 	]
						// }
					},
				]
			},
			echartsData: [],
		}
	},
	mounted() {
		console.log(this.select_value)
		this.statusList(this.getPastDate(this.select_value), this.getPastDate(0));
	},
	watch: {
		deviceId(newValue, oldValue) {
			this.statusList(this.getPastDate(this.select_value), this.getPastDate(0));
		},
		value(newValue, oldValue) {
			console.log(newValue);
		},
		select_value(newValue, oldValue) {
			this.statusList(this.getPastDate(newValue), this.getPastDate(0));
		}
	},
	methods: {
		drawLine() {
			const myChart = echarts.init(document.getElementById("echarts"));
			myChart.setOption(this.option);
		},
		statusList(beginDate, endDate) {
			this.$axios.get("/cabinet/statusList", {
				params: {
					machineId: this.deviceId,
					beginDate,
					endDate,
					current: 1,
					size: 99999
				}
			}).then(res => {
				const {records} = res.data.data;
				const temperatureArr = [];
				const createTimeArr = [];

				records.reverse().forEach(({nowPower, createTime}) => {
					temperatureArr.push(nowPower);
					createTimeArr.push(createTime);
				});

				this.option = {

					title: {
						text: '瞬时功率',
						left: 'center',
					},
					tooltip: {
						trigger: 'axis',
						// formatter: function (params) {
						// 	console.log(params);
						// }
					},
					grid: {
						left: '5%',
						right: '10%',
						bottom: '10%'
					},
					xAxis: {
						data: createTimeArr
					},
					yAxis: {},
					// toolbox: {
					// 	right: 10,
					// 	feature: {
					// 		dataZoom: {
					// 			yAxisIndex: 'none'
					// 		},
					// 		restore: {},
					// 		saveAsImage: {}
					// 	}
					// },
					dataZoom: [
						{
							startValue: '2014-06-01'
						},
						{
							type: 'inside'
						}
					],
					// visualMap: {
					// 	top: 50,
					// 	right: 10,
					// 	pieces: [
					// 		{
					// 			gt: 0,
					// 			lte: 50,
					// 			color: '#93CE07'
					// 		},
					// 		{
					// 			gt: 50,
					// 			lte: 100,
					// 			color: '#FBDB0F'
					// 		},
					// 		{
					// 			gt: 100,
					// 			lte: 150,
					// 			color: '#FC7D02'
					// 		},
					// 		{
					// 			gt: 150,
					// 			lte: 200,
					// 			color: '#FD0100'
					// 		},
					// 		{
					// 			gt: 200,
					// 			lte: 300,
					// 			color: '#AA069F'
					// 		},
					// 		{
					// 			gt: 300,
					// 			color: '#AC3B2A'
					// 		}
					// 	],
					// 	outOfRange: {
					// 		color: '#999'
					// 	}
					// },
					series: [
						{
							name: '功率',
							type: 'line',
							data: temperatureArr,
							// markLine: {
							// 	silent: true,
							// 	lineStyle: {
							// 		color: '#333'
							// 	},
							// 	data: [
							// 		{
							// 			yAxis: 50
							// 		},
							// 		{
							// 			yAxis: 100
							// 		},
							// 		{
							// 			yAxis: 150
							// 		},
							// 		{
							// 			yAxis: 200
							// 		},
							// 		{
							// 			yAxis: 300
							// 		}
							// 	]
							// }
						},
					]
				};

				this.drawLine();
			}).catch(err => {
				// this.drawLine();
			})
		},
		getPastDate(n) {
			const today = new Date();
			const pastDate = new Date(today);
			pastDate.setDate(today.getDate() - n);

			const year = pastDate.getFullYear();
			const month = String(pastDate.getMonth() + 1).padStart(2, '0');
			const day = String(pastDate.getDate()).padStart(2, '0');
			const hours = String(pastDate.getHours()).padStart(2, '0');
			const minutes = String(pastDate.getMinutes()).padStart(2, '0');
			const seconds = String(pastDate.getSeconds()).padStart(2, '0');

			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		}
	}
});
</script>

<style scoped>
.chart {
	height: 400px;
	width: 100%;
}

.date-select {
	width: 100px;
	position: absolute;
	left: 5%;
	z-index: 10;
}

.data-container {
	margin: 15px;
	padding: 15px;
	border: 1px solid #EBEEF5;
	border-radius: 2px;
	position: relative;
}
</style>
